export function resourcesSlider() {
    const $sliders = $(".resources-slider");
    const $window = $(window);
    const $point = 567;
    let $destroy = true;
    let $windowWidth;
    $windowWidth = detectWindowWidth();
    slideDetect();
    $window.on("resize", function () {
        $windowWidth = detectWindowWidth();
        slideDetect();
    });
    function detectWindowWidth() {
        return $window.innerWidth();
    }
    function slideDetect() {
        if ($windowWidth <= $point && $destroy) {
            $sliders.each(function () {
                $(this).slick({
                    dots: true,
                    arrows: false,
                    infinite: false,
                    draggable: true,
                    slidesToScroll: 1,
                    slidesToShow: 1.13,
                    mobileFirst: true,
                });
            });
            $destroy = false;
        } else if ($windowWidth > $point && !$destroy) {
            $sliders.each(function () {
                $(this).slick("unslick");
            });
            $destroy = true;
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/resourcesSlider.js